import React, {Component, createRef} from "react";
import SelectionButton from "./gemeinde_email/SelectionButton";
import GemForm from "./components/GemForm";
import GemFormField from "./components/GemFormField";
import PropTypes from "prop-types";

class GemLogin extends Component {

  constructor(props) {
    super(props);
    this.refUserInputField = createRef();
    this.refPasswordInputField = createRef();
  }

  getToken = async () => {
    this.setState({ loading: true });

    try {
      const response = await fetch(
        "https://api.strapi.peer.kiwi/api/auth/local",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "identifier": this.refUserInputField.current.refInputField.current.value,
            "password": this.refPasswordInputField.current.refInputField.current.value
          })
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Laden der E-Mails");
      }
      const result = await response.json();
      if (result.jwt) {
        this.props.onLogin(result.jwt);
      } else {
        alert('Bitte Passwort eingeben!');
      }
    } catch (error) {
      alert('Bitte Passwort eingeben!');
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return <GemForm>
      <div className="mb-4">
        <h1 className="text-green-400 text-lg font-semibold">
          Anmelden
        </h1>
        <p className="text-sm text-gray-400">
          Hier kannst du dich anmelden.
        </p>
        <GemFormField ref={this.refUserInputField} labelText='Benutzer' id='username' type='text' placeholder='hier bitte den Benutzername eintragen'/>
        <GemFormField ref={this.refPasswordInputField} labelText='Passwort' id='password' type='password' placeholder='hier bitte das Passwort eintragen'/>
      </div>
      <SelectionButton text='Anmelden' onClick={(e) => this.getToken(e)}/>
    </GemForm>;
  }
}

GemLogin.propTypes = {
  onLogin: PropTypes.func
}
export default GemLogin;
